// pages/Home.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Pages.css';
import HeroSection from '../components/HeroSection';
import SetupStore from '../components/SetupStore';
import StoreOptions from '../components/StoreOptions';
import StoreLaunchKit from '../components/StoreLaunchKit';
import StoreGoesLive from '../components/StoreGoesLive';
import Packages from '../components/Packages';
import BeforeStart from '../components/BeforeStart';
import ProductCate from '../components/ProductCate';
import LaunchStore from '../components/LaunchStore';

const Home = () => {
  const location = useLocation();

  // Handle hash navigation on page load
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');
      const element = document.getElementById(sectionId);
      if (element) {
        setTimeout(() => {
          const navbarHeight = 80;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navbarHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="page-container home-page">
      {/* HeroSection Section */}
      <section id="hero">
        <HeroSection />
      </section>

      {/* SetupStore Section */}
      <section id="setup-store">
        <SetupStore />
      </section>

      {/* StoreOptions Section */}
      <section id="store-options">
        <StoreOptions />
      </section>

      {/* StoreLaunchKit Section */}
      <section id="store-launch-kit">
        <StoreLaunchKit />
      </section>

      {/* StoreGoesLive Section */}
      <section id="store-goes-live">
        <StoreGoesLive />
      </section>

      {/* Packages Section */}
      <section id="packages">
        <Packages />
      </section>

      {/* BeforeStart Section */}
      <section id="before-start">
        <BeforeStart />
      </section>

      {/* ProductCate Section */}
      <section id="product-categories">
        <ProductCate />
      </section>

      {/* LaunchStore Section */}
      <section id="launch-store">
        <LaunchStore />
      </section>
    </div>
  );
};

export default Home;